export default "__VITE_ASSET__dac46ce8__"